﻿import { StringEditor, ImageUploadEditor, URLEditor, EmailAddressEditor, BooleanEditor, HtmlContentEditor, MultipleImageUploadEditor, PrefixedContext } from "@serenity-is/corelib";
import { initFormType } from "@serenity-is/corelib/q";

export interface TenantForm {
    TenantName: StringEditor;
    TenantLogo: ImageUploadEditor;
    Contact: StringEditor;
    ContactMobile: StringEditor;
    Address: StringEditor;
    WebSite: URLEditor;
    Fax: StringEditor;
    Email: EmailAddressEditor;
    TenantTelephone: StringEditor;
    Authenticated: BooleanEditor;
    Introduction: HtmlContentEditor;
    Qualifications: MultipleImageUploadEditor;
}

export class TenantForm extends PrefixedContext {
    static formKey = 'Administration.Tenant';
    private static init: boolean;

    constructor(prefix: string) {
        super(prefix);

        if (!TenantForm.init)  {
            TenantForm.init = true;

            var w0 = StringEditor;
            var w1 = ImageUploadEditor;
            var w2 = URLEditor;
            var w3 = EmailAddressEditor;
            var w4 = BooleanEditor;
            var w5 = HtmlContentEditor;
            var w6 = MultipleImageUploadEditor;

            initFormType(TenantForm, [
                'TenantName', w0,
                'TenantLogo', w1,
                'Contact', w0,
                'ContactMobile', w0,
                'Address', w0,
                'WebSite', w2,
                'Fax', w0,
                'Email', w3,
                'TenantTelephone', w0,
                'Authenticated', w4,
                'Introduction', w5,
                'Qualifications', w6
            ]);
        }
    }
}